export default {
  wrapper: {},
};
